import axios from 'axios'

const BASE_URL_ME = '/me'

export const getConnectedAccountsService = async () =>
  axios.get(`${BASE_URL_ME}/connected-accounts`).then(({ data }) => data)

export const disconnectConnectedAccountService = async ({ provider }) =>
  axios.delete(`${BASE_URL_ME}/connected-accounts/${provider}`).then(({ data }) => data)

export const setPasswordService = async ({ password }) =>
  axios.post(`${BASE_URL_ME}/password`, { password }).then(({ data }) => data)
